import { render, staticRenderFns } from "./Conversation.vue?vue&type=template&id=8461bf60&"
import script from "./Conversation.vue?vue&type=script&lang=ts&"
export * from "./Conversation.vue?vue&type=script&lang=ts&"
import style0 from "./Conversation.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports